export enum BillingsTaxiTaxiUpdateStatusRequestStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
  REOPENED = "REOPENED",
}

export type BillingsTaxiTaxiUpdateStatusRequestBody = {
  status: BillingsTaxiTaxiUpdateStatusRequestStatus;
  comment?: string;
};

type BillingsTaxiTaxiUpdateStatusRequest = {
  billingUuid: string;
  status: BillingsTaxiTaxiUpdateStatusRequestStatus;
  comment?: string;
};

export default BillingsTaxiTaxiUpdateStatusRequest;
